import React, { useContext } from 'react';
import { CircularProgress } from '@material-ui/core';

import { SedimentSpillContext } from 'containers/SedimentSpill';

const Progress = () => {
  const { refs, state } = useContext(SedimentSpillContext);
  const { animationLoading } = state;
  const { mapRef } = refs;
  if (animationLoading && mapRef.current) {
    return (
      <div
        style={{
          zIndex: 500,
          position: 'absolute',
          left: '50%',
          top: '50%',
        }}
      >
        <CircularProgress color="primary" size={40} />
      </div>
    );
  }
  return null;
};

export default Progress;
